import { Button } from '@mui/joy';

import { AnnotationQueueSchema, DatasetSchema } from '@/types/schema';
import { cn } from '@/utils/tailwind';

export const ShowAllPickerExtraItem = ({
  showAll,
  resources,
  setShowAll,
  hasSelectedTags,
  pickerType = 'dataset',
  className,
}: {
  showAll: boolean;
  resources?: (AnnotationQueueSchema | DatasetSchema)[];
  setShowAll: (showAll: boolean) => void;
  hasSelectedTags: boolean;
  pickerType?: string;
  className?: string;
}) => {
  const hideToggleButton =
    (showAll && resources && resources.length === 0) || !hasSelectedTags;
  return (
    <div className={cn('flex items-center justify-start gap-2', className)}>
      <span className="text-sm text-disabled">
        {showAll || !hasSelectedTags
          ? `${
              !resources || resources.length === 0
                ? `No ${pickerType}s found.`
                : `Showing ${resources.length} ${pickerType}s.`
            }`
          : `Some ${pickerType}s hidden by resource tags.`}
      </span>
      {hideToggleButton ? null : (
        <Button
          sx={{ flex: 'none', ml: 1 }}
          variant="plain"
          size="sm"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowAll(!showAll);
          }}
        >
          {showAll ? 'Tagged only' : 'Show all'}
        </Button>
      )}
    </div>
  );
};
